import { render, staticRenderFns } from "./LegalAid.vue?vue&type=template&id=6ef05890&scoped=true&"
import script from "./LegalAid.vue?vue&type=script&lang=js&"
export * from "./LegalAid.vue?vue&type=script&lang=js&"
import style0 from "./LegalAid.vue?vue&type=style&index=0&id=6ef05890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef05890",
  null
  
)

export default component.exports